import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ROUTES } from "../../routes/sectionConfig";

/**
 * Renders children only when user has the required role.
 * Otherwise redirects to the default route for the current user's role.
 */
export default function RoleRoute({ role, children }) {
  const { userType } = useAuth();

  if (userType !== role) {
    const to = userType === "doctor" ? ROUTES.doctorHome : ROUTES.home;
    return <Navigate to={to} replace />;
  }

  return children;
}
